import { Navigate } from "react-router-dom";
import Main from "../main";
const Protectedroute = ({ children, agentid }) => {
    const isAuthenticated = !!localStorage.getItem("sessionid");
    console.log(isAuthenticated,"isAuthenticated")
  return isAuthenticated ? <Main/> : <Navigate to="/login" replace />;
};

export default Protectedroute;